<template>
  <div class="buorg" style="height: 100%;">
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile">
        <div class=" b m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center">


           <div class="m-grid__item">
            <h1 style="font-size: 5rem; font-weight: bolder" class="text-light">404</h1>
            <h4 class="text-light mt-n4">{{$t('error.PageNotFound')}}</h4>
           </div>

          <div class="m-grid__item mt-n2">
            <img alt="" src="https://d1pk7baiyvt4yj.cloudfront.net/assets/v-bbc69dd/img/logos/white.png" style="width:100px">
          </div>

          <div class="m-grid__item text-light mt-3 pl-5 pr-5">
            {{$t('error.ThisPageWasNotFound')}}
          </div>
          <ul class="list-inline mt-3">
            <li class="d-inline">
              <router-link :to="{ name: 'Dashboard'}" class="m-menu__item text-light text-uppercase">
                {{ $t('menus.main.overview') }}
              </router-link>
            </li>
            <li class="d-inline text-light">
              -
            </li>
            <li class="d-inline">
              <router-link :to="{ name: 'Support'}" class="m-menu__item text-light text-uppercase">
                {{ $t('common.support') }}
              </router-link>
            </li>
          </ul>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/dashboard/common/NotFound.vue